import React, { useState } from "react";
import Layout from "../layout/Layout";
import secondImage from "../assets/secondImage.png";

const JOBS = [
  {
    id: 1,
    title: "Veterinary Consultant",
    type: "Full-time / Remote",
    description: "Provide medical expertise for content creation, product formulation feedback, and support user queries.",
    requirements: [
      "DVM or equivalent veterinary degree.",
      "3+ years of clinical experience with small animals (cats & dogs).",
      "Excellent communication and writing skills."
    ]
  },
  {
    id: 2,
    title: "Frontend React Developer",
    type: "Full-time / Remote",
    description: "Build beautiful, highly interactive web applications and user experiences for pet owners.",
    requirements: [
      "3+ years of React and TailwindCSS experience.",
      "Experience building responsive, accessible, and fast web apps.",
      "Strong eye for typography, micro-interactions, and visual detail."
    ]
  },
  {
    id: 3,
    title: "Creative Content Specialist",
    type: "Part-time / Remote",
    description: "Craft engaging stories, informational articles, and newsletters for our cat and dog owner communities.",
    requirements: [
      "Proven portfolio of pet care or lifestyle writing.",
      "Understanding of SEO best practices.",
      "Creative storytelling ability and passion for pets."
    ]
  }
];

const Careers = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({ name: "", email: "", resume: "", note: "" });
  const [applied, setApplied] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleApply = (e) => {
    e.preventDefault();
    const { name, email, resume } = formData;
    if (!name.trim() || !email.trim() || !resume.trim()) {
      setError("Please fill in all required fields.");
      return;
    }
    setApplied(true);
    setError("");
    setTimeout(() => {
      setApplied(false);
      setFormData({ name: "", email: "", resume: "", note: "" });
      setSelectedJob(null);
    }, 2500);
  };

  return (
    <Layout>
      <div className=" flex h-[92vh] px-10">
        {/* left content */}
        <div className=" lg:w-1/2 w-full mt-24 z-10 pb-10 overflow-y-auto max-h-[80vh] pr-4">
          <div className=" max-w-[80%]">
            {selectedJob ? (
              <div>
                <button
                  onClick={() => {
                    setSelectedJob(null);
                    setApplied(false);
                    setError("");
                  }}
                  className=" mb-6 text-sm font-semibold text-black bg-[#F5D8CE] px-4 py-2 rounded-xl hover:bg-opacity-80 transition-colors"
                >
                  ← Back to Open Positions
                </button>
                <span className=" text-sm text-[#6D6D6D] block mb-2">{selectedJob.type}</span>
                <h1 className=" text-3xl font-bold text-[#3E3E3E] mb-4">
                  {selectedJob.title}
                </h1>
                <p className=" text-[#6D6D6D] text-[16px] leading-relaxed mb-6">
                  {selectedJob.description}
                </p>

                <h3 className=" text-lg font-bold text-[#3E3E3E] mb-3">Requirements:</h3>
                <ul className=" list-disc list-inside text-[#6D6D6D] text-[15px] space-y-2 mb-8 pl-2">
                  {selectedJob.requirements.map((req, idx) => (
                    <li key={idx}>{req}</li>
                  ))}
                </ul>

                {applied ? (
                  <div className=" bg-[#FCEBE5] p-6 rounded-xl text-center">
                    <h4 className=" text-xl font-bold text-[#3E3E3E] mb-1">Application Submitted!</h4>
                    <p className=" text-[#6D6D6D] text-sm">Thank you for applying. We'll be in touch soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleApply} className=" border-t border-[#F5D8CE] pt-8">
                    <h3 className=" text-lg font-bold text-[#3E3E3E] mb-4">Apply for this Position</h3>
                    {error && <p className=" text-red-500 text-sm mb-4 font-medium">{error}</p>}
                    
                    <div className=" flex flex-col gap-4">
                      <div className=" bg-white rounded-lg px-4 py-2 flex items-center">
                        <label htmlFor="name" className=" w-[30%] text-sm text-[#6D6D6D]">Full Name</label>
                        <input
                          id="name"
                          name="name"
                          type="text"
                          required
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Your name"
                          className=" border-none px-2 py-1 w-[70%] focus:outline-none"
                        />
                      </div>

                      <div className=" bg-white rounded-lg px-4 py-2 flex items-center">
                        <label htmlFor="email" className=" w-[30%] text-sm text-[#6D6D6D]">Email</label>
                        <input
                          id="email"
                          name="email"
                          type="email"
                          required
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Your email address"
                          className=" border-none px-2 py-1 w-[70%] focus:outline-none"
                        />
                      </div>

                      <div className=" bg-white rounded-lg px-4 py-2 flex items-center">
                        <label htmlFor="resume" className=" w-[30%] text-sm text-[#6D6D6D]">Resume Link</label>
                        <input
                          id="resume"
                          name="resume"
                          type="url"
                          required
                          value={formData.resume}
                          onChange={handleChange}
                          placeholder="Link to portfolio or PDF"
                          className=" border-none px-2 py-1 w-[70%] focus:outline-none"
                        />
                      </div>

                      <div className=" bg-white rounded-lg px-4 py-2 flex items-start">
                        <label htmlFor="note" className=" w-[30%] text-sm text-[#6D6D6D] mt-1">Cover Note</label>
                        <textarea
                          id="note"
                          name="note"
                          rows="3"
                          value={formData.note}
                          onChange={handleChange}
                          placeholder="Why do you want to join Cats & Dogs? (Optional)"
                          className=" border-none px-2 py-1 w-[70%] focus:outline-none resize-none"
                        />
                      </div>

                      <div className=" flex justify-end">
                        <button type="submit" className="bg-black text-white px-10 py-2 rounded-2xl hover:bg-opacity-80 transition-colors">
                          Submit Application
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            ) : (
              <div>
                <h1 className=" text-4xl font-bold text-[#3E3E3E] mb-2">
                  Careers
                </h1>
                <p className=" text-[#6D6D6D] text-[16px] mb-10">
                  Build the future of pet care with us. Join a team dedicated to loving cats and dogs.
                </p>

                <div className=" flex flex-col gap-6">
                  {JOBS.map((job) => (
                    <div
                      key={job.id}
                      onClick={() => setSelectedJob(job)}
                      className=" bg-[#FCEBE5] p-6 rounded-xl cursor-pointer hover:bg-opacity-80 transition-all border border-transparent hover:border-[#F5D8CE] group"
                    >
                      <span className=" text-xs font-semibold text-[#6D6D6D] block mb-1">{job.type}</span>
                      <h2 className=" text-xl font-bold text-[#3E3E3E] group-hover:text-black transition-colors">
                        {job.title}
                      </h2>
                      <p className=" text-[#6D6D6D] text-sm mt-2">
                        {job.description}
                      </p>
                      <span className=" inline-block mt-4 text-sm font-semibold text-black group-hover:underline">
                        Apply Now →
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Pane (Static Image to support the white Navbar links) */}
        <div className=" lg:w-1/2 w-full h-full absolute top-0 right-0">
          <div
            className=" h-full"
            style={{
              backgroundImage: `url(${secondImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        </div>
      </div>
    </Layout>
  );
};

export default Careers;
